import { Button, ButtonProps } from "@mui/material";
import { extendProps } from "../../../helpers/common";

export type LinkButtonProps = ButtonProps;

function LinkButton(props: LinkButtonProps) {
    const newProps = extendProps(props, {
        disableRipple: true,
        sx: {
            padding: 0,
            fontSize: {
                xs: 14,
                md: 16,
            },
            fontWeight: 400,
            textTransform: "none",
            color: "primary.main",
            textDecoration: "underline",
            "&:hover": {
                textDecoration: "none",
                backgroundColor: "transparent",
            },
        },
    });

    return <Button {...newProps} />;
}

export default LinkButton;
